// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-TU_","delete":"styles_delete__2EhQK","update":"styles_update__3h_OA","add":"styles_add__2AcRH"};